import React, { Fragment, useEffect, useState, useContext } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import { Alert } from "reactstrap";
import {
  ContactContext,
  AsesorSelectorContext,
  AsesorsContext,
} from "../../ContextProvider";

const AsesorsSelector = ({ register, setValue }) => {
  //contact  context

  const { item: contactData, setActiveButton } = useContext(ContactContext);

  //listo los asesores disponibles
  const { tableData, currentPage, getAsesors, rowsPerPage } =
    useContext(AsesorsContext);

  //manejo de asesores seleccionados
  const {
    setContactAsesors,
    contactAsesors,
    getContactAsesors,
    apiErrors,
    setApiErrors,
  } = useContext(AsesorSelectorContext);

  const handleInputChange = (input, e) => {
    setActiveButton(true);
    setValue("asesors", input);
    setContactAsesors(input);
  };

  //alert
  const [alertOpen, setAlertOpen] = useState(
    apiErrors && apiErrors.length > 0 ? true : false
  );

  const ToggleAlert = () => setAlertOpen(!alertOpen);

  //usefect
  useEffect(() => {
    setAlertOpen(apiErrors && apiErrors.length > 0 ? true : false);
  }, [apiErrors]);

  useEffect(() => {
    getAsesors(currentPage, rowsPerPage);
  }, [currentPage]);

  useEffect(() => {
    return () => {
      setApiErrors([]);
      setContactAsesors([]);
    };
  }, []);

  useEffect(() => {
    if (contactData?.id) getContactAsesors(contactData?.id);
  }, [contactData?.id]);

  useEffect(() => {
    console.log(contactAsesors);
  }, [contactAsesors]);

  return (
    <Fragment>
      <Alert
        className="alert-dismissible"
        color="danger inverse"
        isOpen={alertOpen}
        toggle={ToggleAlert}
      >
        <i class="icon-alert"></i>
        {apiErrors && apiErrors.length > 0 ? apiErrors[0] : ""}
      </Alert>

      <input type="hidden" name="asesors" {...register("asesors", {})}></input>

      <Typeahead
        id="public-typeahead"
        selected={contactAsesors}
        labelKey="name"
        multiple
        options={tableData}
        placeholder="Selecciona los asesores..."
        onChange={handleInputChange}
      />
    </Fragment>
  );
};

export default AsesorsSelector;
